import { render, staticRenderFns } from "./buyCarMonthCardList.vue?vue&type=template&id=f2373174&scoped=true"
import script from "./buyCarMonthCardList.vue?vue&type=script&lang=js"
export * from "./buyCarMonthCardList.vue?vue&type=script&lang=js"
import style0 from "./buyCarMonthCardList.vue?vue&type=style&index=0&id=f2373174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2373174",
  null
  
)

export default component.exports